import React, { useEffect, useMemo } from 'react'
import DropDownOA from '../../../../common/dropDownOA'
import { Item, SuccessPopUp } from '../../../../common/snippets'
import { Button, Paper, Stack, TableContainer } from '@mui/material'
import { Checkbox, FormControlLabel, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@mui/material'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { useState } from 'react'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import EditIcon from '@mui/icons-material/Edit'
import { branchTypeList, getYearList, monthNamesList } from '../gsReportsConst'
import { cellStyles, headerCellStyles } from '../gsReportsConst'
import { focusElemnt, isEmpty, navigation1, navigation3 } from '../../../../common/helper'
import { XMarkSvg } from '../../../../common/svg/xMark'
import { CheckMarkSvg } from '../../../../common/svg/checkMark'
import { updateAlertError } from '../../../../../store/common/common_action'
import { connect } from 'react-redux'
import { getMonthlyTargetUpdate, getMonthlytargetTableData } from '../../../../../store/generalSetting/GSAction'
import moment from 'moment'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import { useTheme } from "@mui/material/styles";
import { useTranslation } from '../../../../../i18n/I18nProvider'

const MonthlyTargetTable = (props) => {
  const { translations, language } = useTranslation()
  const cs = translations?.common || {}
  const { data, updateAlertError, getMonthlytargetTableData, getMonthlyTargetUpdate } = props
  const { common, generalSettingReducer } = data
  const { loginData } = common
  const { monthlyTargetTableData } = generalSettingReducer
  
  const generalSettingsTranslations = translations?.generalSettings
  const gs = generalSettingsTranslations || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const translatedBranchTypeList = useMemo(() => branchTypeList.map((item) =>
    item.id === 0
      ? { ...item, name: generalSettingsTranslations?.gsAll || item.name }
      : item
  ), [generalSettingsTranslations])
  const [tableData, setTableData] = useState([])
  const [filterValues, setFilterValues] = useState({});
  const [filteredData, setfilteredData] = useState(tableData)
  const [manageFocus, setManageFocus] = useState(false)
  //filters
  const [month, setMonth] = useState('')
  const [year, setYear] = useState('')
  const [selectBranch, setSelectBranch] = useState(branchTypeList[0])
  const [handleFilter, setHandleFilter] = useState(false)
  const [yearList, setYearList] = useState('')
  const [branchType, setBranchType] = useState('')
  const [isSuccess, setIsSuccess] = useState(false)
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [editData, setEditData] = useState({})
  useEffect(() => {
    setSelectBranch((prev) => {
      const translatedSelection = translatedBranchTypeList.find((item) => item.id === prev?.id)
      return translatedSelection || prev
    })
  }, [translatedBranchTypeList])

  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  const theme = useTheme()
  // let dataA = { branch: 'Bangalore Cargo Office', city: 'Bangalore', state: 'Karnataka', target: 100000, status: 1 }
  const date = moment(); // This will create a moment object representing the current date and time
  const yearData = date.year();
  useEffect(() => {

    if (!isEmpty(loginData)) {
      let tempMonth={} //monthNamesList
      let tempYear=getYearList(yearData - 1, yearData + 1)
      setYearList(tempYear)
      setYear(tempYear[1])
      tempMonth=monthNamesList?.filter((val)=>val.name===moment().format('MMMM'))
      setMonth(tempMonth[0])
    }
    
  }, [loginData])
  useEffect(() => {
    focusElemnt('mtMonthName')
  }, [])
  useEffect(() => {
    if (monthlyTargetTableData?.length > 0) {
      let newData = monthlyTargetTableData
      let newDataB = newData?.map((val) => ({ ...val, editBtn: true, targetValue: val.TargetAmount, statusValue: val.IsActive }))
      setTableData(newDataB)
    }
  }, [monthlyTargetTableData])
  useEffect(() => {
    const filteredDataTemp = tableData.filter((item) => {
        return columnDefs.every((column) => {
            const filterValue = filterValues[column.field] || "";
            const value = item[column.field]?.toString()
            return filterValue ? value && value.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
        })
    })
    setfilteredData(filteredDataTemp)
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [filterValues])
useEffect(() => {
  setfilteredData(tableData)
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [tableData])
const handleChangeContain = (e, name) => {
  let value = e.target.value;
  setFilterValues((prevFilterValues) => ({
      ...prevFilterValues,
      [name]: value
  }));
}
  const columnDefs = [
    { headerName: tr('gsSN', 'SN'), headerSx: { minWidth: "5%", textAlign: 'right' }, field: "SN", dataType: "string", showfilter: false, allowSorting: false },
    { headerName: tr('branchName', 'Branch Name'), headerSx: { minWidth: "37%" }, field: "BranchName", dataType: "string", showfilter: true, allowSorting: false },
    { headerName: tr('rpCity', 'City'), headerSx: { minWidth: "13%" }, field: "CityName", dataType: "string", showfilter: true, allowSorting: false },
    { headerName: tr('rpState', 'State'), headerSx: { minWidth: "13%" }, field: "StateName", dataType: "string", showfilter: true, allowSorting: false },
    { headerName: tr('rpTarget', 'Target'), headerSx: { minWidth: "12%", textAlign: 'right' }, field: "targetValue", dataType: "string", showfilter: false, allowSorting: false },
    { headerName: tr('gsStatus', 'Status'), headerSx: { minWidth: "10%", textAlign: 'center' }, field: "statusValue", dataType: "time", showfilter: false, allowSorting: false },
    { headerName: tr('gsEdit', 'Edit'), headerSx: { minWidth: "9%" }, field: "Edit", dataType: "string", showfilter: false, allowSorting: false },
  ]
  const handleHideEditBtn = (index) => {
    let newVal = [...filteredData]
    if (index >= 0 && index <= newVal?.length) {
      for (let i = 0; i < newVal?.length; i++) {
        if (i === index) {
          newVal[i].editBtn = !newVal[i].editBtn
        } else {
          newVal[i].editBtn = true
        }
      }
      setfilteredData(newVal)
      focusElemnt(`editBtn-${index + 1}`)
      newVal[index].editBtn === true ? setManageFocus(false) : setManageFocus(true)
    }
  }
  const handleCrossBtn = (index) => {
    let newVal = [...filteredData]
    if (index >= 0 && index <= newVal?.length) {
      newVal[index].targetValue = filteredData[index].TargetAmount
      newVal[index].statusValue = filteredData[index].IsActive
      newVal[index].editBtn = !newVal[index].editBtn
      setfilteredData(newVal)
      // setTimeout(() => {
      //     focusElemnt(`editBtn-${index + 1}`)
      // }, 0)
    }
  }
  const handleRowEdit = (Item, index) => {
    if (Item?.targetValue === '') {
      updateAlertError({ show: true, msg: tr('rpPleaseEnterMonthlyTarget', 'Please Enter The Monthly Target Value'), success: false, nextId: `mtTargetValue-${index}` })
      return
    } else {
      let obj = {
        ParentCompanyID: editData?.ParentCompanyID,
        CompanyID: editData?.ChildCompanyID,
        BranchID:editData?.BranchID,
        Date:`${year?.year}-${month?.id}-01`,
        TargetAmount:Number(editData?.targetValue),
        UserID: loginData?.intUserID,
        IsActive: editData?.statusValue,
      }
      getMonthlyTargetUpdate(obj)?.then((res) => {
        if (res?.Status === 'success') {
          setIsSuccess(true)
        } else {
          updateAlertError({ show: true, msg: res.Message, success: false, nextId: `maBranchName` })
        }
      }).catch((err) => {
        console.log("Error:", err)
      })
    }
  }
  const handleRowChkChange = (e, index) => {
    setManageFocus(false)
    let newVal = [...filteredData]
    if (index >= 0 && index <= newVal?.length) {
      newVal[index].statusValue = e.target.checked ? 1 : 0
      setfilteredData(newVal)
    }
    setTimeout(() => {
      focusElemnt(`chkbox-${index}`)
    }, 0)
  }
  const handleInputChange = (e, index) => {
    let value = e.target.value.replace(/[^\d]/g, '');
    let newVal = [...filteredData]
    if (index >= 0 && index <= newVal?.length) {
      newVal[index].targetValue = value
      setEditData(newVal)
    }
  }
  const EmptyTableRow = () => {
    return (
      <TableRow>
        <TableCell colSpan={7}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '15px',
              marginBottom: '15px',
              color: 'red',
              fontSize: '14px',
            }}
          >
            <span>{tr('noResultsSelectedFilters', 'No results found for the selected filters.')}</span>
          </div>
        </TableCell>
      </TableRow>
    )
  }
  const MonthlyTargetTblRow = (props) => {
    const { item, index } = props
    return (
      <TableRow key={`monthly-target-${index}`} style={{ minHeight: '36px' }}>
        <TableCell style={{ ...cellStyles, width: '5%', textAlign: 'right' }}> {index + 1} </TableCell>
        <TableCell style={{ ...cellStyles, width: '37%' }}> {item.BranchName} </TableCell>
        <TableCell style={{ ...cellStyles, width: '13%' }}> {item.CityName} </TableCell>
        <TableCell style={{ ...cellStyles, width: '13%' }}> {item.StateName} </TableCell>
        {item.editBtn ? <TableCell style={{ ...cellStyles, width: '12%', textAlign: 'right' }}> {item.targetValue} </TableCell> :
          <TableCell className="input--wrapper" style={{ ...cellStyles, padding: '4px 4px', width: '12%' }}>
            <Item sx={{ width: '100%', padding: '0px' }}>
              <input
                id={`mtTargetValue-${index}`}
                name={`mtTargetValue-${index}`}
                className='input--style'
                autoFocus={manageFocus}
                style={{ fontSize: "12px", textAlign: "right", maxHeight: '29px' }}
                value={item?.targetValue || ''}
                onChange={(e) => handleInputChange(e, index)}
                onKeyDown={(e) => { navigation1(e, `chkbox-${index}`, `checkMark-${index}`) }}
              />
            </Item>
          </TableCell>}

        {item.editBtn ? <TableCell sx={{ ...cellStyles, width: '10%', textAlign: 'center' }}>
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
            {item.statusValue === 1 ? <CheckMarkSvg /> : <XMarkSvg />}
          </span></TableCell> : <TableCell style={{ ...cellStyles, width: '10%', padding: '0px 0px', textAlign: 'center' }}>
          <FormControlLabel
            value="end"
            sx={{ marginX: '0px', maxHeight: '36px' }}
            control={
              <Checkbox
                id={`chkbox-${index}`}
                checked={item.statusValue === 1}
                onChange={(e) => handleRowChkChange(e, index)}
                sx={{ fontSize: '12px', backgroundColor: 'transparent !important', padding: '0px 0px', textAlign: 'center' }}
                onKeyDown={(e) => {
                  navigation1(e, `checkMark-${index}`, `mtTargetValue-${index}`)
                }}
              />
            }
            labelPlacement="end"
          />
        </TableCell>}
        {item.editBtn ? <TableCell style={{ ...cellStyles, width: '9%' }}>
          <span id={`editBtn-${index}`} tabIndex={0} style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold', width: '52px', padding: '2px 4px', marginLeft: '-6px' }}
            onClick={() => { handleHideEditBtn(index) }}
            onKeyDown={(e) => navigation3(e, index === filteredData?.length - 1 ? 'mtMonthName' : `editBtn-${index + 1}`, index === 0 ? "monthlyTargetGoBtn" : `editBtn-${index - 1}`, () => { handleHideEditBtn(index); })}
          >
            <EditIcon sx={{ marginRight: '3px' }} />
            {tr('gsEdit', 'Edit')}
          </span></TableCell> :
          <TableCell style={{ ...cellStyles, width: '9%', padding: '0px 0px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
              <span tabIndex={0} key={`checkMark-${index}`} id={`checkMark-${index}`}
                onClick={() => { setEditData(item); setShowConfirmation(true) }}
                style={{ marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px' }}
                onKeyDown={(e) => navigation3(e, `xMark-${index}`, `chkbox-${index}`, () => { setEditData(item); setShowConfirmation(true) })}
              >
                <CheckCircleOutlinedIcon tabIndex={0} style={{ color: '#4CAF50', marginTop: '1px' }} fontSize='large' />
              </span>
              <span key={`xMark-${index}`} tabIndex={0} id={`xMark-${index}`}
                onClick={() => handleCrossBtn(index)}
                style={{ marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px' }}
                onKeyDown={(e) => navigation3(e, `mtTargetValue-${index}`, `checkMark-${index}`, () => handleCrossBtn(index))}
              >
                <CancelOutlinedIcon tabIndex={0} style={{ color: 'red', marginTop: '1px' }} fontSize="large" />
              </span>
            </div>
          </TableCell>}
      </TableRow>
    )
  }
  const handleClickGo = () => {
    const obj = {
      CompanyID: loginData?.intCompanyID,
      Date: `${year?.year}-${month?.id}-01`,
      Mode: selectBranch?.id
    }
    getMonthlytargetTableData(obj)
    setHandleFilter(true)
  }
  const ShowMonthlyTargetConfirmation = () => {
    const data = {
      successMessage: tr('rpSaveMonthlyTargetStatus', 'Do you want to save the updated Monthly Target Status?'),
      otherMessage: '',
      buttonId1: '',
      buttonId2: '',
      headTxt: tr('monthlyTarget', 'Monthly Target'),
      fontSize:'16px',
      yesAction: () => { handleRowEdit(); setShowConfirmation(false) },
      noAction: () => setShowConfirmation(false)
    }
    return <SuccessPopUp data={data} updateModal={setShowConfirmation} />
  }
  return (
    <>
      <Stack style={{ display: 'flex', flexDirection: 'row', gap: '10px', paddingTop: '5px' }}>
        <Item sx={sx.itemsx} style={{ width: '10%' }}>
          <DropDownOA
            id='mtMonthName'
            defaultvalue={month?.name}
            // value={props.modalType ? ModalData.rec.IdProofType.IDProof : ModalData.send.IdProofType.IDProof}
            label={tr('rpMonth', 'Month')}
            // onSelect={(BookingType) => handleProofDrop(BookingType)}
            data={monthNamesList || []}
            idKey={`id`}
            dataKey={`name`}
            prevId=''
            nextId='mtYear'
            onSelect={(val) => { setMonth(monthNamesList.find((m) => m.id === val.id) || val); setHandleFilter(false) }}
          // width="100%"
          // searchPlaceholder={'Search ID Type'}
          // id={iid.senderIdtype}
          // nextId={props.modalType ? iid.recIdProof : iid.senIdProof}
          />
        </Item>
        <Item sx={sx.itemsx} style={{ width: '10%' }}>
          <DropDownOA
            id='mtYear'
            defaultvalue={year?.year}
            // value={props.modalType ? ModalData.rec.IdProofType.IDProof : ModalData.send.IdProofType.IDProof}
            label={tr('rpYear', 'Year')}
            prevId='mtMonthName'
            nextId='mtBranchType'
            // onSelect={(BookingType) => handleProofDrop(BookingType)}
            data={yearList}
            dataKey={`year`}
            idKey={`year`}
            onSelect={(val) => { setYear(val); setHandleFilter(false) }}
          // width="100%"
          // searchPlaceholder={'Search ID Type'}
          // id={iid.senderIdtype}
          // nextId={props.modalType ? iid.recIdProof : iid.senIdProof}
          />
        </Item>
        <Item sx={sx.itemsx} style={{ width: '10%' }}>
          <DropDownOA
            key={`mtBranchType-${language}`}
            id='mtBranchType'
            defaultvalue={selectBranch?.name}
            // value={props.modalType ? ModalData.rec.IdProofType.IDProof : ModalData.send.IdProofType.IDProof}
            label={tr('rpBranchType', 'Branch Type')}
            // onSelect={(BookingType) => handleProofDrop(BookingType)}
            data={translatedBranchTypeList}
            dataKey={`name`}
            idKey={`id`}
            prevId='mtYear'
            nextId='monthlyTargetGoBtn'
            onSelect={(val) => { setSelectBranch(translatedBranchTypeList.find((b) => b.id === val.id) || val); setHandleFilter(false) }}
          // width="100%"
          // searchPlaceholder={'Search ID Type'}
          // id={iid.senderIdtype}
          // nextId={props.modalType ? iid.recIdProof : iid.senIdProof}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <Button
            variant="contained"
            id='monthlyTargetGoBtn'
            style={{ ...sx.fullHeight, ...sx.novp }}
            className="btn btn-primary"
            onClick={handleClickGo}
            onKeyDown={(e) => navigation1(e, 'editBtn-0', 'mtBranchType')}
          >
            {tr('goUpper', 'GO')}
          </Button>
        </Item>
      </Stack>
      {handleFilter ?
        <>
          <Stack style={{ maxHeight: '60vh', marginTop: '10px' }}>
            <TableContainer className="lr-popup-table lrModel  scrollBlue" style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px' }} component={Paper}>
              <Table style={{ border: "none", overflow: 'auto' }} stickyHeader id="monthlyTargetTbl" className="table1 table-Received " size="small" aria-label="a dense table">
                <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
                  <TableRow key='foc-tbl-header' style={{ background: '#d9edff' }}>
                    {columnDefs.map((col, index) =>
                      <TableCell key={`TH-${index}`} sx={{ ...col.headerSx, padding: '7px 12px', backgroundColor: '#DAEDFE', minHeight: '40px', fontFamily: 'Roboto', fontSize: '12px', fontWeight: '600', color: '#444444', paddingTop: "10px", paddingBottom: "8px" }}>
                        {col.headerName}
                      </TableCell>
                    )}
                  </TableRow>
                  <TableRow key='foc-tbl-filter-row' style={{ background: '#d9edff' }}>
                    <TableCell style={{ ...cellStyles, padding: '7px 12px', width: '7%' }} ></TableCell>
                    <TableCell style={{ ...cellStyles, padding: '7px 12px', width: '37%' }}  >
                      <div className="filter-input" style={{ fontSize: '12px' }}>
                        <input
                          className="field"
                          name="cancelSearchInput"
                          placeholder={tr('contains', 'Contains')}
                          onChange={(e) => {
                              handleChangeContain(e, 'BranchName')
                          }}
                          style={{ width: '100%', paddingTop: '5px' }}
                        />
                        <FilterAltIcon style={{ fontSize: 'medium', color: '#AAA' }} />
                      </div>
                    </TableCell>
                    <TableCell style={{ ...cellStyles, fontSize: '12px', padding: '7px 12px', width: '12%' }} >
                      <div className="filter-input" style={{ fontSize: '12px' }}>
                        <input
                          className="field"
                          name="cancelSearchInput"
                          placeholder={tr('contains', 'Contains')}
                          onChange={(e) => {
                              handleChangeContain(e, 'CityName')
                          }}
                          style={{ width: '100%', paddingTop: '5px' }}
                        />
                        <FilterAltIcon style={{ fontSize: 'medium', color: '#AAA' }} />
                      </div>
                    </TableCell>
                    <TableCell style={{ fontSize: '12px', padding: '7px 12px', width: '12%' }} >
                      <div className="filter-input" style={{ fontSize: '12px' }}>
                        <input
                          className="field"
                          name="cancelSearchInput"
                          placeholder={tr('contains', 'Contains')}
                          onChange={(e) => {
                              handleChangeContain(e, 'StateName')
                          }}
                          style={{ width: '100%', paddingTop: '5px' }}
                        />
                        <FilterAltIcon style={{ fontSize: 'medium', color: '#AAA' }} />
                      </div>
                    </TableCell>
                    <TableCell style={{ ...cellStyles, padding: '7px 12px', alignContent: 'flex-end', width: '12%' }} >
                      <div className="filter-input" style={{ fontSize: '12px', }}>
                        <input
                          className="field"
                          name="cancelSearchInput"
                          placeholder={tr('contains', 'Contains')}
                          onChange={(e) => {
                              handleChangeContain(e, 'targetValue')
                          }}
                          style={{ width: '100%', paddingTop: '5px' }}
                        />
                        <FilterAltIcon style={{ fontSize: 'medium', color: '#AAA' }} />
                      </div>
                    </TableCell>
                    <TableCell style={{ fontSize: '12px', width: '10%' }} ></TableCell>
                    <TableCell style={{ fontSize: '12px', width: '9%' }} ></TableCell>
                  </TableRow>
                </TableHead>
                {
                  filteredData?.length > 0 ?
                    <>
                      <TableBody className="filter-data-row" style={{ border: "none" }}>
                        {filteredData?.map((item, index) => (
                          <MonthlyTargetTblRow item={item} index={index} key={index} />
                        ))}
                      </TableBody>
                    </> :
                    <>
                      <TableBody>
                        <EmptyTableRow />
                      </TableBody>
                    </>
                }
              </Table>
            </TableContainer>
          </Stack>
        </>
        : null
      }
      {showConfirmation && <ShowMonthlyTargetConfirmation />}
      <SuccessAndErrorModal handleClose={() => { setIsSuccess(false); handleClickGo(); focusElemnt('mvnMgmtBranchName') }} open={isSuccess} title={cs.monthlyTargetStatusSavedSuccessfullyNl || 'Monthly Target Status\nSaved Successfully!'} modalStyle={modalStyle} />
    </>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = { updateAlertError, getMonthlytargetTableData, getMonthlyTargetUpdate }
export default connect(mapStateToProps, mapDispatchToProps)(MonthlyTargetTable)

